import MailvistaLogo from "@/components/images/MailvistaLogo";
import { Button } from "@/components/ui/button";
import routes from "@/router/routes";
import { t } from "i18next";
import { useEffect } from "react";
import { useNavigate, useNavigationType } from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate();
    const navigationType = useNavigationType();

    useEffect(() => {
        if (navigationType === "POP") {
            navigate(routes.dashboard, { replace: true });
        }
    }, [navigationType, navigate]);

    return (
        <div className="flex h-screen w-full flex-col items-center justify-center bg-surface-background p-8 text-center">
            <MailvistaLogo className="mb-6 h-24 w-24" />
            <h1 className="text-6xl font-bold text-text-active">404</h1>
            <p className="mt-4 text-lg text-text-body">{t("notFound.title")}</p>
            <p className="mt-2 text-text-caption">
                {t("notFound.description")}
            </p>
            <Button
                className="mt-6"
                onClick={() => navigate(routes.root)}
                variant="outline"
            >
                {t("notFound.goHome")}
            </Button>
        </div>
    );
};

export default NotFound;
